import findPosts from "../components/postsFilter";
import createCustomSelect from "../components/customSelect";

(function ($) {
  $(document).ready(function ($) {
    let regionPath = $(".map__region");
    let wrapperElement = $(".municipalities__content__wrapper");
    let wrapperSelects = $(".municipalities__content__select");
    let ajax = $("#map-ajax").val();
    let observer = document.getElementById("observer-municipalities");
    let municipalitiesSelect = $("#municipalities-select");
    let municipalitiesCustomSelect;
    let municipalitiesCustomSelectOptions;

    let requestData = {
      postType: "municipio",
      currentPage: 1,
      postsPerPage: 6,
    };

    regionPath.click(function () {
      municipalitiesCustomSelect = $(".select-selected");
      municipalitiesCustomSelectOptions = $(".select-items");

      let region = $(this).data("region");
      let labels = $(`.map__label`);
      let regions = $(`.map__region`);
      let currentLabel = $(`.map__label[data-region="${region}"]`);
      let currentRegion = $(`.map__region[data-region="${region}"]`);
      labels.removeClass("active");
      regions.removeClass("active");
      currentLabel.addClass("active");
      currentRegion.addClass("active");

      if (ajax) {
        let requestRegionData = {
          postType: "region",
          region: region,
        };

        $(".loading-message").remove();
        wrapperSelects.append(
          '<p class="loading-message">Cargando municipios...</p>'
        );
        wrapperElement.css("display", "none");
        municipalitiesCustomSelect.remove();
        municipalitiesCustomSelectOptions.remove();

        findPosts(
          requestRegionData,
          responseRegion,
          "overwrite",
          wrapperElement
        );
      }
    });

    wrapperSelects.change(function () {
      requestData.municipality = municipalitiesSelect.val();
      requestData.currentPage = 1;

      if (observer) {
        intersectionObserver.unobserve(observer);
      }

      findPosts(
        requestData,
        responseMunicipalities,
        "overwrite",
        wrapperElement
      );
    });

    const intersectionObserver = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting) {
          requestData.currentPage++;
          if (observer) {
            intersectionObserver.unobserve(observer);
          }

          findPosts(
            requestData,
            responseMunicipalities,
            "append",
            wrapperElement
          );
        }
      },
      {
        rootMargin: "0px",
      }
    );

    if (observer) {
      intersectionObserver.observe(observer);
    }

    function responseMunicipalities(res) {
      // $('.posts-filter__loading-message').remove();

      if (res.length) {
        let html = "";

        res.forEach((element) => {
          html += renderMunicipality(element);
        });

        if (requestData.currentPage === 1) {
          wrapperElement.html(html);
          wrapperElement.css("display", "flex");

          if (observer) {
            intersectionObserver.observe(observer);
          }
        } else {
          wrapperElement.append(html);

          if (observer) {
            intersectionObserver.observe(observer);
          }
        }

        if (res.length === 1) {
          if (observer) {
            intersectionObserver.unobserve(observer);
          }
        }
      } else {
        if (requestData.currentPage === 1) {
          wrapperElement.html(
            '<p class="not-found-message">No existen municipios que coincidan con la búsqueda</p>'
          );
        }
        if (observer) {
          intersectionObserver.unobserve(observer);
        }
      }

      $(".posts-filter__loading-message").remove();
    }

    function renderMunicipality(element) {
      let html = `
                <a href="${element.permalink}" class="municipalities__content__wrapper__item">
                    <img class="municipalities__content__wrapper__item__icon" src="${element.map}">
                    ${element.thumbnail}
                    <h3 class="title_h3">${element.title}</h3>
                </a>
			`;
      return html;
    }

    function responseRegion(res) {
      if (res.length === 1) {
        if (res[0].fields) {
          if (res[0].fields.muncipios) {
            let html = "<option value>Municipio</option>";

            res[0].fields.muncipios.forEach((municipality) => {
              html += `<option value="${municipality.ID}">${municipality.post_title}</option>`;
            });

            municipalitiesSelect.html(html);
            createCustomSelect();
            $(".loading-message").remove();
          } else {
            $(".loading-message").html(
              "No existen municipios que coincidan con la búsqueda"
            );
          }
        }
      }
    }
  });
})(jQuery);
